<template>
  <div class="main-page">
    <center-spinner :loading="loading" />

    <div class="auth-content">
      <div>
        <img
          src="../../../assets/img/new_app_logo.png"
          class="logo"
        >
      </div>

      <h1 class="header-style">
        Register Now
      </h1>

      <div
        v-if="verificationFailed"
        class="fail-message-style mb-4"
      >
        <p class="fail-style">
          <v-icon
            color="#C62828"
            size="30"
          >
            mdi-alert
          </v-icon>
          <br>
          {{ verificationFailedMessage }}
        </p>
      </div>

      <p class="subheader-style">
        Enter your mobile number.
      </p>

      <v-form>
        <vue-phone-number-input
          v-model="phone"
          class="mb-4"
          :default-country-code="'AU'"
          @update="onPhoneUpdate"
        />

        <v-btn
          class="mt-5 btn-style register-button"
          elevation="0"
          @click="verifyMobile"
        >
          Next
        </v-btn>

        <v-btn
          light
          color="#E6E6E6"
          class="mt-3 btn-style cancel-button"
          elevation="0"
          @click="cancelRegister"
        >
          Cancel
        </v-btn>
      </v-form>
    </div>
  </div>
</template>

<script>
import spinner from '../../components/SpinnerCentre.vue';
import Constants from 'src/constants';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import { countries } from '../../../countries';
export default {
  name: 'RegisterPage',

  components: {
    VuePhoneNumberInput,
    'center-spinner': spinner,
  },

  data () {
    return {
      loading: false,
      phone: null,
      nationalNumber: null,
      verificationFailed: false,
      verificationFailedMessage: '',
      countryName: null,
    };
  },

  methods: {
    onPhoneUpdate (data) {
      if (data && data.isValid) {
        this.nationalNumber = data.nationalNumber;
        this.countryCode = data.countryCode;

        this.countryName = this.getCountryName(data.countryCode);
      } else {
        this.nationalNumber = null;
        this.countryCode = null;

        this.countryName = null;
      }
    },
    getCountryName (code) {
      if (
        typeof Intl !== 'undefined' &&
        typeof Intl.DisplayNames === 'function'
      ) {
        try {
          const regionNames = new Intl.DisplayNames(['en'], { type: 'region' });
          const name = regionNames.of(code);
          if (name) return name;
        } catch (e) {}
      }

      const country = countries.find((c) => c.code === code);
      if (country) return country.name;

      return code;
    },
    async verifyMobile () {
      if (!this.nationalNumber) {
        this.$store.dispatch(
          'alert/onAlert',
          {
            message: 'Enter a valid number',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        return;
      }

      this.loading = true;
      this.verificationFailed = false;

      let orgId = null;
      try {
        const raw = localStorage.getItem('orgDetails');
        if (raw) orgId = JSON.parse(raw).external_id || null;
      } catch {}

      const payload = {
        phone_number: this.nationalNumber,
        organization_id: orgId,
        country_code: this.countryName,
      };

      try {
        await this.$store.dispatch('register/verifyMobileNumber', {
          phone_number: this.nationalNumber,
          organization_id: orgId,
          country_code: this.countryName,
        });

        localStorage.setItem('ph_number', JSON.stringify(payload));

        this.$router.push({
          name: 'OtpVerification',
          params: { mobileNumber: this.nationalNumber },
        });
      } catch (err) {
        this.verificationFailed = true;

        if (
          err &&
          err.response &&
          err.response.data &&
          err.response.data.message
        ) {
          this.verificationFailedMessage = err.response.data.message;

          if (err.response.data.code === 5002) {
            this.$router.push({ name: 'Login' });
          }
        } else {
          this.verificationFailedMessage = 'Verification failed';
        }
      }

      this.loading = false;
    },

    cancelRegister () {
      this.$router.push({ name: 'GetStarted' });
    },
  },
};
</script>

<style scoped>
.register-button {
  font-size: 15px;
  border-radius: 30px;
  background-color: #000 !important;
}

.cancel-button {
  font-size: 15px;
  border-radius: 30px;
}

.logo {
  width: 50px;
  margin-bottom: 10px;
}

/* Ensure dropdown visible */
::v-deep(.vue-phone-number-input .country-selector__list) {
  background-color: #ffffff !important;
}

::v-deep(.vue-phone-number-input .country-selector__list__item) {
  color: #000000 !important;
}
</style>
